import actions from "./actions";

const initState = {
  usersReports: [],
  loading: false,
};

export default function usersReportsReducer(
  state = initState,
  { type, ...action }
) {
  switch (type) {
    case actions.USERS_REPORTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actions.USERS_REPORTS_SUCCESS:
      return {
        ...state,
        usersReports: action.usersReports,
        loading: false,
      };
    default:
      return state;
  }
}
